import { TicketSelectorOption } from "./ticket-selector-option.interface";

export interface TicketSelectorOptions {
  popular: TicketSelectorOption,
  others: TicketSelectorOption[]
}
